import { useEmployeeGrantAccessYardManagement } from '@/core/domain/enterprise/Employees/Employees.hooks';
import { Button, Modal } from 'antd';
import { useEmployeeFormContext } from '../../EmployeeFormProvider';

export default function GrantAccessToEmployeeButton() {
  const { employeeId } = useEmployeeFormContext();
  const grantAccessToEmployee = useEmployeeGrantAccessYardManagement();

  const handleGrantAccessToEmployee = async () => {
    Modal.confirm({
      title: 'Acesso a gestão de pátio',
      content:
        'Deseja realmente conceder ao funcionário o acesso a gestão de pátio?',
      onOk: async () => {
        try {
          await grantAccessToEmployee.mutateAsync(employeeId);
        } catch {}
      },
      okText: 'Sim',
      cancelText: 'Não',
    });
  };

  return (
    <Button block type="primary" onClick={handleGrantAccessToEmployee}>
      Conceder acesso a gestão de pátio
    </Button>
  );
}
